<template>
  <div class="header-container" v-if="cmsConfig && cmsConfig.trade">
    <div class="selector">
      <div class="day">
        <div
          v-for="(item, itemIndex) in dayTabs"
          :key="itemIndex"
          @click="dayChangeHandler(item.key)"
          :class="{
            'item': true,
            'active': item.key === dayKey
          }">{{item.name}}</div>
      </div>
      <div class="index">
        <b-tab-selector class='trade-header index-tab-selector'
          :default-key="1"
          :tabs="cmsConfig.zhsTrade"
          :showTip="showTip"
          @change="indexChangeHandler">
          <template #extra="{data}">
            <div class="extra"><TransNumber :isPercent="data.isPercent" :ifFormatter="data.ifFormatter" :isUnit="data.isUnit" :num="$getValue(headerData || {}, `${data.dataIndex}`, 0)"></TransNumber></div>
          </template>
        </b-tab-selector>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import BTabSelector from "@/components/tab-selector/index";
  import TransNumber from '@/components/TransNumber'
  /**
   * @change 返回对象
   */
  class ChangeData {
    constructor (dayKey, indexKey, dayTabs, indexTabs) {
      this.dayKey = dayKey
      this.indexKey = indexKey
      this.currentDay = dayTabs.find(item => item.key * 1 === dayKey * 1)
      this.currentIndex = indexTabs.find(item => item.key * 1 === indexKey * 1)
    }
  }

  export default {
    name: "tradeHeader",
    components: {
      BTabSelector,
      TransNumber
    },
    props: {
      headerData: {
        type: Object,
        default: () => {}
      },
      showTip: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        dayKey: 1,
        dayTabs: [
          {
            name: '昨日',
            key: 1
          },
          {
            name: '近7天',
            key: 5
          },
          {
            name: '近30天',
            key: 6
          },
        ],
        indexKey: 1,
      }
    },
    computed: {
      ...mapState(['cmsConfig'])
    },
    methods: {
      dayChangeHandler (v) {
        this.dayKey = v
        const { indexKey, dayTabs } = this
        const { trade } = this.cmsConfig
        this.$emit('change', new ChangeData(v, indexKey, dayTabs, trade))
      },
      indexChangeHandler (currentKey) {
        this.indexKey = currentKey
        const { dayKey, dayTabs } = this
        const { trade } = this.cmsConfig
        this.$emit('change', new ChangeData(dayKey, currentKey, dayTabs, trade))
      }
    },
  }
</script>
<style lang="scss">
.header-container{
  .trade-header{
    display: flex;
    .item{
      flex:1;
      padding-left: 0;
      padding-right: 0;
      text-align: center;
    }
  }
}
</style>
<style lang="scss" scoped>
.header-container {
  .update-time {
    @include Flex();
    .time {
      flex: 1;
      font-size: 14px;
      color: $content-color;
    }
    .ops {
      font-size: 12px;
      color: $title-color-999;
    }
  }
  .selector {
    margin-top: 12px;
    @include Flex();
    .day {
      width: 60px;
      display: flex;
      flex-direction: column;

      .item {
        flex:1;
        background: $grey-f7;
        font-size: 12px;
        padding: 2px 8px;
        &:hover {
          cursor: pointer;
        }
        &.active {
          color: #fff;
          background: $primary-main;
        }
      }
    }
    .index{
      flex:1;
    }
  }

}
.extra {
  font-size: 15px;
  color: #121212;
  text-align: center;
}
.index-tab-selector {
  /deep/ .item {
    padding: 10px 5px;
  }
}
</style>
